<template>
  <button
      type="button"
      class="cb"
      :class="['cb--' + variant, { 'cb--icon-only': iconOnly, 'cb--block': block }]"
      :disabled="disabled"
      @click="$emit('click', $event)"
  >
    <md-icon v-if="icon" class="cb__icon">{{ icon }}</md-icon>
    <span v-if="!iconOnly" class="cb__label"><slot>{{ label }}</slot></span>
  </button>
</template>

<script>
/**
 * Reusable button — our own styling (themed #343841). Variants: primary, secondary,
 * danger, ghost. Optional leading md-icon. Use slot or `label` for text.
 */
export default {
  name: 'CustomButton',
  props: {
    label: { type: String, default: '' },
    variant: { type: String, default: 'primary' }, // primary | secondary | danger | ghost
    icon: { type: String, default: '' },
    iconOnly: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.cb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  height: 40px;
  padding: 0 1.4rem;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background .15s ease, box-shadow .15s ease, border-color .15s ease, color .15s ease;
}
.cb:disabled { opacity: 0.55; cursor: not-allowed; }
.cb--block { width: 100%; }
.cb--icon-only { width: 40px; padding: 0; }
.cb__icon { font-size: 18px !important; color: inherit !important; }

/* primary — themed dark */
.cb--primary { background: #343841; color: #fff; }
.cb--primary:not(:disabled):hover { background: #2a2e36; box-shadow: 0 2px 8px rgba(52,56,65,0.25); }

/* secondary — light surface */
.cb--secondary { background: #eef0f3; color: #3b424b; }
.cb--secondary:not(:disabled):hover { background: #e3e6ea; }

/* danger */
.cb--danger { background: #e0524c; color: #fff; }
.cb--danger:not(:disabled):hover { background: #cf463f; }

/* ghost — borderless text */
.cb--ghost { background: transparent; color: #5b626b; }
.cb--ghost:not(:disabled):hover { background: #f1f3f5; color: #2c2c2c; }
</style>
